export function formatPrice(value) {
  if(Number.isInteger(value)){
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }else{
    //ถ้าเป็น ทศนิยมให้แสดง2ตำแหน่ง
    return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
    // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  export function replaceSpecialCharacters (value) {   
    return value.toString().replace(/[^a-zA-Z0-9ก-๏. ]/g, '')
  }
  export function DetectInternalApp(){
    var UA = navigator.userAgent
      var isLINE = function (UA) {
        return UA.indexOf('Line/') > -1
      }

      var isFacebook = function (UA) {
        return UA.indexOf('FBAN') > -1 || UA.indexOf('FBAV/') > -1
      }

      var isWV = function (UA) {
        return UA.indexOf('wv)') > -1
      }

      if (isLINE(UA)) {
        return true
      }
      if (isFacebook(UA)) {
        return true
      }
      if (isWV(UA)) {
        return true
      }

      return false
  }
  